import { render, staticRenderFns } from "./FuneralHomeEcom.vue?vue&type=template&id=7ba3fcf4&scoped=true"
import script from "./FuneralHomeEcom.vue?vue&type=script&lang=js"
export * from "./FuneralHomeEcom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba3fcf4",
  null
  
)

export default component.exports